import createIcon from '../../createIcon';

/**
 * @component @name AutoMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMDU0OSAzLjUzNTM5QzE3LjM4NDkgMi4xNDUzOSAxNS4zMTQ5IDEuMjM1MzkgMTMuMDI0OSAxLjAyNTM5VjMuMDM1MzlDMTQuNzU0OSAzLjIyNTM5IDE2LjMzNDkgMy45MTUzOSAxNy42MzQ5IDQuOTU1MzlMMTkuMDU0OSAzLjUzNTM5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjAyNDkgMy4wMzUzOVYxLjAyNTM5QzguNzM0OSAxLjIyNTM5IDYuNjY0OSAyLjE0NTM5IDQuOTk0OSAzLjUzNTM5TDYuNDE0OSA0Ljk1NTM5QzcuNzE0OSAzLjkxNTM5IDkuMjk0OSAzLjIyNTM5IDExLjAyNDkgMy4wMzUzOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01LjAwNDkgNi4zNjUzOUwzLjU4NDkgNC45NDUzOUMyLjE5NDkgNi42MTUzOSAxLjI4NDkgOC42ODUzOSAxLjA3NDkgMTAuOTc1NEgzLjA4NDlDMy4yNzQ5IDkuMjQ1MzkgMy45NjQ5IDcuNjY1MzkgNS4wMDQ5IDYuMzY1MzlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuOTY0OSAxMC45NzU0SDIyLjk3NDlDMjIuNzY0OSA4LjY4NTM5IDIxLjg1NDkgNi42MTUzOSAyMC40NjQ5IDQuOTQ1MzlMMTkuMDQ0OSA2LjM2NTM5QzIwLjA4NDkgNy42NjUzOSAyMC43NzQ5IDkuMjQ1MzkgMjAuOTY0OSAxMC45NzU0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcuMDI0OSAxMS45NzU0TDEwLjQ2NDkgMTMuNTM1NEwxMi4wMjQ5IDE2Ljk3NTRMMTMuNTg0OSAxMy41MzU0TDE3LjAyNDkgMTEuOTc1NEwxMy41ODQ5IDEwLjQxNTRMMTIuMDI0OSA2Ljk3NTM5TDEwLjQ2NDkgMTAuNDE1NEw3LjAyNDkgMTEuOTc1NFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi4wMjQ5IDIwLjk3NTRDOC45MTQ5IDIwLjk3NTQgNi4xNzQ5IDE5LjM4NTQgNC41NjQ5IDE2Ljk3NTRINy4wMjQ5VjE0Ljk3NTRIMS4wMjQ5VjIwLjk3NTRIMy4wMjQ5VjE4LjI3NTRDNS4wMTQ5IDIxLjExNTQgOC4yOTQ5IDIyLjk3NTQgMTIuMDI0OSAyMi45NzU0QzE2Ljg5NDkgMjIuOTc1NCAyMS4wMjQ5IDE5LjgwNTQgMjIuNDY0OSAxNS40MTU0TDIwLjUwNDkgMTQuOTY1NEMxOS4yNzQ5IDE4LjQ1NTQgMTUuOTQ0OSAyMC45NzU0IDEyLjAyNDkgMjAuOTc1NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoMode = createIcon('AutoMode', [
  [
    'path',
    {
      d: 'M19.0549 3.53539C17.3849 2.14539 15.3149 1.23539 13.0249 1.02539V3.03539C14.7549 3.22539 16.3349 3.91539 17.6349 4.95539L19.0549 3.53539Z',
      key: '1yaple',
    },
  ],
  [
    'path',
    {
      d: 'M11.0249 3.03539V1.02539C8.7349 1.22539 6.6649 2.14539 4.9949 3.53539L6.4149 4.95539C7.7149 3.91539 9.2949 3.22539 11.0249 3.03539Z',
      key: 'x22u7a',
    },
  ],
  [
    'path',
    {
      d: 'M5.0049 6.36539L3.5849 4.94539C2.1949 6.61539 1.2849 8.68539 1.0749 10.9754H3.0849C3.2749 9.24539 3.9649 7.66539 5.0049 6.36539Z',
      key: '1dfkzc',
    },
  ],
  [
    'path',
    {
      d: 'M20.9649 10.9754H22.9749C22.7649 8.68539 21.8549 6.61539 20.4649 4.94539L19.0449 6.36539C20.0849 7.66539 20.7749 9.24539 20.9649 10.9754Z',
      key: '1nwtwy',
    },
  ],
  [
    'path',
    {
      d: 'M7.0249 11.9754L10.4649 13.5354L12.0249 16.9754L13.5849 13.5354L17.0249 11.9754L13.5849 10.4154L12.0249 6.97539L10.4649 10.4154L7.0249 11.9754Z',
      key: '1nep3q',
    },
  ],
  [
    'path',
    {
      d: 'M12.0249 20.9754C8.9149 20.9754 6.1749 19.3854 4.5649 16.9754H7.0249V14.9754H1.0249V20.9754H3.0249V18.2754C5.0149 21.1154 8.2949 22.9754 12.0249 22.9754C16.8949 22.9754 21.0249 19.8054 22.4649 15.4154L20.5049 14.9654C19.2749 18.4554 15.9449 20.9754 12.0249 20.9754Z',
      key: '7ld2xu',
    },
  ],
]);

export default AutoMode;
